import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type AreasDefaultStylesParams = {
  areasDefaultTitleFont: StyleParamType.Font
  areasDefaultTitleColor: StyleParamType.Color
  areasDefaultDescriptionFont: StyleParamType.Font
  areasDefaultDescriptionColor: StyleParamType.Color
  areasDefaultFillOpacityColor: StyleParamType.Color
  areasDefaultBorderOpacityColor: StyleParamType.Color
  areasDefaultBorderWidth: StyleParamType.Number
  areasDefaultCornerRadius: StyleParamType.Number
}

export const areasDefaultStylesParams = createStylesParams<AreasDefaultStylesParams>({
  areasDefaultTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
    metadata: fontMetadata('Body-M', 16, 14),
  },
  areasDefaultTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  areasDefaultDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
    metadata: fontMetadata('Body-M', 14),
  },
  areasDefaultDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  areasDefaultFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
  },
  areasDefaultBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
    metadata: colorMetadata(StyleType.borderColor, 'color-line', 0.12),
  },
  areasDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  areasDefaultCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})

export type AreasHoverStylesParams = {
  areasHoverTitleFont: StyleParamType.Font
  areasHoverTitleColor: StyleParamType.Color
  areasHoverDescriptionFont: StyleParamType.Font
  areasHoverDescriptionColor: StyleParamType.Color
  areasHoverFillOpacityColor: StyleParamType.Color
  areasHoverBorderOpacityColor: StyleParamType.Color
  areasHoverBorderWidth: StyleParamType.Number
  areasHoverCornerRadius: StyleParamType.Number
}

export const areasHoverStylesParams = createStylesParams<AreasHoverStylesParams>({
  areasHoverTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
    metadata: fontMetadata('Body-M', 16, 14),
  },
  areasHoverTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.7),
    metadata: colorMetadata(StyleType.color, 'color-5', 0.7),
  },
  areasHoverDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
    metadata: fontMetadata('Body-M', 14),
  },
  areasHoverDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  areasHoverFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
  },
  areasHoverBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
    metadata: colorMetadata(StyleType.borderColor, 'color-line', 0.12),
  },
  areasHoverBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  areasHoverCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})

export type AreasSelectedStylesParams = {
  areasSelectedTitleFont: StyleParamType.Font
  areasSelectedTitleColor: StyleParamType.Color
  areasSelectedDescriptionFont: StyleParamType.Font
  areasSelectedDescriptionColor: StyleParamType.Color
  areasSelectedFillOpacityColor: StyleParamType.Color
  areasSelectedBorderOpacityColor: StyleParamType.Color
  areasSelectedBorderWidth: StyleParamType.Number
  areasSelectedCornerRadius: StyleParamType.Number
}

export const areasSelectedStylesParams = createStylesParams<AreasSelectedStylesParams>({
  areasSelectedTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
    metadata: fontMetadata('Body-M', 16, 14),
  },
  areasSelectedTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  areasSelectedDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
    metadata: fontMetadata('Body-M', 14),
  },
  areasSelectedDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  areasSelectedFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 0.1),
  },
  areasSelectedBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: colorMetadata(StyleType.borderColor, 'color-8', 1),
  },
  areasSelectedBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  areasSelectedCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})
